import type { MakePaymentV3Params } from 'services/repositories/payment/makePaymentV3';
import { generateUniqueId } from './generateUniqueId';

type PaymentMethodPayload = MakePaymentV3Params['paymentMethods'][number];

interface BuildBankSlipInstallmentPaymentMethodParams {
  /**
   * Valor a ser dividido entre as N invoices de boleto, em centavos
   * (CREDAN-05 AC7/AC8: o restante da compra após a entrada em cartão/Pix).
   */
  amountInCents: number;
  /** Número de boletos (box do T13, limitado por `plan.maxBankSlipInstallments`). */
  installments: number;
  /**
   * Vencimento da 1ª parcela (seletor do T14): dia 05/15/25, ISO
   * `YYYY-MM-DD`.
   */
  firstDueDate: string;
}

/**
 * Monta a perna de boleto parcelado de `POST /v3/payment` (CREDAN-05 /
 * FIN-7199, re-arquitetura Parte 10): combina a seleção de parcelas do box
 * (T13) com a data de vencimento da 1ª parcela (T14) no formato exato do
 * contrato confirmado — `{ type: 'bank-slip', amount, installments,
 * firstDueDate }`, sem aninhar em um objeto `boleto`. O tipo `bank-slip`
 * (distinto do enum `PaymentMethod`, que não tem mais
 * `bank-slip-installment`) é o mesmo usado pelo boleto imediato; o bff
 * discrimina o fluxo parcelado pela PRESENÇA de `firstDueDate`.
 */
export function buildBankSlipInstallmentPaymentMethod({
  amountInCents,
  installments,
  firstDueDate,
}: BuildBankSlipInstallmentPaymentMethodParams): PaymentMethodPayload {
  return {
    virtualId: generateUniqueId(),
    type: 'bank-slip',
    amount: amountInCents,
    installments,
    firstDueDate,
  };
}
